<template>
  <div class="w-full">
    <Button
      v-if="authStore.active_signup_step > 1"
      @click="handleBack"
      variant="paper-primary"
      size="sm"
      class="hidden lg:flex absolute -top-8"
    >
      <template #icon>
        <Icon name="ChevronLeft" class="h-4 w-4" />
      </template>
    </Button>
    <div class="flex gap-2 w-full justify-start">
      <div
        v-for="step in stepsArray"
        :key="step"
        @click="handleClick(step)"
        class="h-[6px] w-full rounded"
        :class="
          authStore.active_signup_step >= step
            ? 'bg-navbar-invest-bg-tracked'
            : 'bg-navbar-invest-bg-track'
        "
      ></div>
    </div>
  </div>
</template>

<script setup>
import { computed } from "vue";
import { useRouter, useRoute } from "vue-router";

import { Button, Icon } from "@/components";
import { useAuthStore } from "@/stores";

const authStore = useAuthStore();
const router = useRouter();
const route = useRoute();

const props = defineProps({
  numSteps: {
    type: Number,
    required: true,
  },
});

const emit = defineEmits(["set-active-step"]);

const stepsArray = computed(() => Array.from({ length: props.numSteps }, (_, i) => i + 1));

const handleClick = (step) => {
  emit("set-active-step", step);
};

const routeMap = {
  "/sign-up": 1,
  "/sign-up/personal-details": 2,
  "/sign-up/set-password": 3,
  "/sign-up/acknowledgements": 4,
  "/sign-up/auth-verification": 5,
};

function handleBack() {
  authStore.active_signup_step = routeMap[route.path] - 1 || 1;
  router.back();
}
</script>
